import { render, staticRenderFns } from "./SystemCapitalRecord.vue?vue&type=template&id=7d4a5646&scoped=true"
import script from "./SystemCapitalRecord.vue?vue&type=script&lang=js"
export * from "./SystemCapitalRecord.vue?vue&type=script&lang=js"
import style0 from "./SystemCapitalRecord.vue?vue&type=style&index=0&id=7d4a5646&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4a5646",
  null
  
)

export default component.exports